var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutstationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_52_6545)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8939 54.3693C48.5523 54.3693 48.2754 54.0936 48.2754 53.7539V40.277C48.2754 39.9373 48.5523 39.6616 48.8939 39.6616C49.2354 39.6616 49.5123 39.9373 49.5123 40.277V53.7539C49.5123 54.0936 49.2354 54.3693 48.8939 54.3693Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 54.3693C41.6588 54.3693 41.3818 54.0936 41.3818 53.7539V40.277C41.3818 39.9373 41.6588 39.6616 42.0003 39.6616C42.3418 39.6616 42.6188 39.9373 42.6188 40.277V53.7539C42.6188 54.0936 42.3418 54.3693 42.0003 54.3693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1058 54.3693C34.7642 54.3693 34.4873 54.0936 34.4873 53.7539V40.277C34.4873 39.9373 34.7642 39.6616 35.1058 39.6616C35.4473 39.6616 35.7242 39.9373 35.7242 40.277V53.7539C35.7242 54.0936 35.4473 54.3693 35.1058 54.3693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1446 34.1406H46.7551V26.2308H48.6686C49.0102 26.2308 49.2871 25.9551 49.2871 25.6154C49.2871 25.2757 49.0102 25 48.6686 25H35.3314C34.9898 25 34.7129 25.2757 34.7129 25.6154C34.7129 25.9551 34.9898 26.2308 35.3314 26.2308H37.2449V34.1406H31.8554C30.8323 34.1406 30 34.9686 30 35.9868V57.9606C30 58.9788 30.8323 59.8068 31.8554 59.8068H32.7945C32.5332 61.5812 34.0283 63.1538 35.7954 63.1538C37.5622 63.1538 39.0575 61.5812 38.7963 59.8068H45.204C44.9425 61.5812 46.4378 63.1538 48.2046 63.1538C49.9717 63.1538 51.4665 61.5812 51.2055 59.8068H52.1446C53.1677 59.8068 54 58.9788 54 57.9606V35.9868C54 34.9686 53.1677 34.1406 52.1446 34.1406ZM38.4818 26.2308H45.5182V34.1406H38.4818V26.2308ZM37.5898 60.2015C37.5898 61.1508 36.7846 61.9231 35.7954 61.9231C34.8062 61.9231 34.0009 61.1508 34.0009 60.2015C34.0009 60.0677 34.0182 59.9357 34.0505 59.8065H37.54C37.5723 59.9357 37.5898 60.0677 37.5898 60.2015ZM49.9991 60.2015C49.9991 61.1508 49.1938 61.9231 48.2046 61.9231C47.2154 61.9231 46.4102 61.1508 46.4102 60.2015C46.4102 60.0677 46.4274 59.9357 46.46 59.8065H49.9495C49.9818 59.936 49.9991 60.0677 49.9991 60.2015ZM52.7631 57.9606C52.7631 58.3 52.4855 58.576 52.1446 58.576H31.8554C31.5145 58.576 31.2369 58.3 31.2369 57.9606V35.9868C31.2369 35.6474 31.5145 35.3714 31.8554 35.3714H52.1446C52.4855 35.3714 52.7631 35.6474 52.7631 35.9868V57.9606Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_6545",
    x1: 26.5,
    y1: 8.5,
    x2: 56,
    y2: 78.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033F49",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstationIcon);
export default __webpack_public_path__ + "static/media/outstation-icon.d24852f2eb287e4137973294e91ecdc8.svg";
export { ForwardRef as ReactComponent };